import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import "@styles/components/tooltip.css";

const fn = {
    init: () => {
        // Filter sidebar tooltip
        tippy("[data-tooltip]", {
            theme: "light",
            placement: "right-start",
            content: (ref) => {
                return ref.getAttribute("aria-describedby");
            },
            allowHTML: true,
            touch: true,
            trigger: 'mouseenter click',
        });

        const printLink = document.getElementById("mobile-action-links").getAttribute("data-print-link")
        const downloadLink = document.getElementById("mobile-action-links").getAttribute("data-download-link")

        // More options tooltip
        tippy("[data-more-tooltip]", {
            theme: "light",
            placement: "bottom",
            content: `
                <div class='flex flex-col gap-y-4 px-4 py-2'>
                    <a href='` + printLink + `' class='flex items-center gap-x-2' target="_blank" rel="noopener noreferrer nofollow">
                        <span>
                            <svg width="20" height="18.571" viewBox="0 0 20 18.571" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.171 3.103H3.829a0.39 0.39 0 0 1 -0.391 -0.387v-1.009A1.714 1.714 0 0 1 5.157 0h9.689a1.714 1.714 0 0 1 1.719 1.707V2.714c0 0.214 -0.176 0.387 -0.391 0.387m1.717 1.244H2.11C0.946 4.346 0 5.284 0 6.44v7.293c0 1.156 0.946 2.094 2.11 2.094h1.329V12.724c0 -1.54 1.26 -2.793 2.811 -2.793h7.5c1.55 0 2.813 1.253 2.813 2.793v3.103h1.329c1.163 0 2.109 -0.939 2.109 -2.094V6.44c0 -1.156 -0.946 -2.094 -2.11 -2.094M3.751 9a0.934 0.934 0 0 1 -0.939 -0.931c0 -0.514 0.42 -0.93 0.939 -0.93 0.517 0 0.937 0.416 0.937 0.93s-0.42 0.931 -0.937 0.931" fill="#000"/><path d="M13.75 11.793h-7.5a0.934 0.934 0 0 0 -0.937 0.931v4.344c0 0.514 0.419 0.931 0.937 0.931h7.5a0.934 0.934 0 0 0 0.937 -0.931v-4.343a0.934 0.934 0 0 0 -0.937 -0.933" fill="#000"/></svg>
                        </span>
                        <p class='theme-link font-bold text-base lg:text-lg'>Print</p>
                    </a>
                    <a href='` + downloadLink + `' class='flex items-center gap-x-2' target="_blank" rel="noopener noreferrer nofollow">
                        <span>
                            <svg width="20" height="23.333" viewBox="0 0 20 23.333" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m15.855 10.437 -1.012 -1.167a0.762 0.762 0 0 0 -1.083 -0.072L10.747 11.877V0.777A0.773 0.773 0 0 0 9.978 0h-1.537c-0.423 0 -0.767 0.35 -0.767 0.778v11.098l-3.017 -2.678a0.762 0.762 0 0 0 -1.083 0.072l-1.01 1.165a0.783 0.783 0 0 0 0.07 1.1l6.07 5.383a0.762 0.762 0 0 0 1.012 0L15.783 11.533a0.783 0.783 0 0 0 0.07 -1.1m1.8 9.788H0.768A0.773 0.773 0 0 0 0 21v1.555c0 0.43 0.343 0.778 0.767 0.778h16.887c0.423 0 0.767 -0.35 0.767 -0.778V21a0.773 0.773 0 0 0 -0.767 -0.778" fill="#000"/></svg>
                        </span>
                        <p class='theme-link font-bold text-base lg:text-lg'>Download</p>
                    </a>
                </div>`,
            allowHTML: true,
            touch: true,
            trigger: "click",
            interactive: true,
        });
    },
};

export default {
    can: () => document.querySelector("[data-tooltip]") || document.querySelector("[data-more-tooltip]"),
    run: fn.init,
};
